module.exports = __webpack_public_path__ + "static/media/ticket.eff7d4e6.jpg";